import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { useConselhoDetailsDispatch } from './conselho-details-context';
import { ACTION_TYPES } from './conselho-details-reducer';

export const useConselhoDetailsController = () => {
  const dispatch = useConselhoDetailsDispatch();

  const loadConselhoDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getConselho(id);

      dispatch({ type: ACTION_TYPES.setConselhoDetails, payload: response });
    } catch (error) {
      console.error('Error loading conselho details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes do conselho' });
      dispatch({ type: ACTION_TYPES.setConselhoDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearConselhoDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setConselhoDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  return {
    loadConselhoDetails,
    clearConselhoDetails,
  };
};
